import type { BulkEntryState } from './types';

export const initialState: BulkEntryState = {
  counselorMB: undefined,
  mb: undefined,
  selectedVersion: undefined,
  validationErrors: {},
  selectedYouth: [],
  selectedRequirements: [],
  completionDate: undefined,
  comment: '',
  counselorApproved: false,
};
